<template>
    <ClassroomLayout>
        <div class="classroom-device">
            <h3>Sorry. Your device is not compatible with our classroom.</h3>
            <p>
                Our online classroom requires a computer with a physical keyboard and screen-sharing. Tablets and phones
                don't support these features well, so you wouldn't be able to participate or write code effectively.
            </p>
            <p>
                Please try again using a <strong>laptop or desktop computer</strong>.
            </p>
        </div>
    </ClassroomLayout>
</template>

<script setup>

import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";

</script>

<style lang="scss" scoped>
.classroom-device {
    text-align: center;
    max-width: 600px;
    padding: 0 20px;
    margin: 0 auto;

    &-button {
        display: flex;
        justify-content: center;
        margin-top: 2rem;
    }

    h3 {
        margin-bottom: 50px
    }
}
</style>
